import {
  LOCALE_ID,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_CONTEXT_TOKEN, AppContext } from './context';

// Services
import {
  AnalyticsService,
  CheckRoomService,
  DateService,
  DetailService,
  DeviceService,
  DisneyService,
  HotelsResultsService,
  I18nService,
  InjectHeaderAndFooterWCService,
  MapService,
  MdToastService,
  PriceService,
  RecommendedHotelsService,
  RoomBookingService,
  ScrollService,
  SearchStateService,
  TripadvisorService,
  URLService,
} from '@core/services';
import { AlliancesServicesService } from '@am/alliance-service';
import { AmExpertsToolsControlService } from '@am/experts-tools-control';
import { Ga4Service } from './services/ga4.service';
import { Ga4WrapperService } from '@am/ga4-wrapper';
import { ExpertsTripWrapperService } from '@core/services/experts-trip-wrapper.service';
import { TrivagoService } from '@core/services/trivago.service';
import { LoaderInterceptor } from '@core/interceptors/loader.interceptor';
import { LoadingService } from '@core/services/loading/loading.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    Ga4WrapperService,
    DateService,
    MapService,
    InjectHeaderAndFooterWCService,
    DeviceService,
    URLService,
    PriceService,
    ScrollService,
    TripadvisorService,
    SearchStateService,
    AnalyticsService,
    RoomBookingService,
    HotelsResultsService,
    RecommendedHotelsService,
    CheckRoomService,
    DetailService,
    DisneyService,
    MdToastService,
    I18nService,
    AlliancesServicesService,
    AmExpertsToolsControlService,
    Ga4Service,
    LoadingService,
    { provide: APP_CONTEXT_TOKEN, useValue: AppContext },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: 'BASE_URL_NTPM', useValue: '' },
    {
      provide: 'autocomplete-base-token',
      useValue: '/autocomplete',
    },
    {
      provide: 'destination-base-token',
      useValue: '/api/home/destinations',
    },
    {
      provide: 'analytics-category-token',
      useValue: 'HTL|Results',
    },
    ExpertsTripWrapperService,
    TrivagoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded, import it only in the AppModule');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [],
    };
  }
}
